import React from 'react';
import { cn } from '@/lib/utils';

/**
 * RotatingBorderLabel - Text box with animated rotating border gradient
 */
const RotatingBorderLabel = ({ 
  children, 
  className = '', 
  duration = 2,
  borderWidth = 1
}) => {
  return (
    <div 
      className={cn(
        "relative inline-block rounded-full bg-background overflow-hidden",
        className
      )}
      style={{ padding: `${borderWidth}px` }}
    >
      <div 
        className="absolute inset-0 h-[2000%] w-[500%] -left-[250%] -top-[1000%] bg-gradient-to-r from-background from-25% to-violet-500 to-80%"
        style={{
          animation: `spin ${duration}s linear infinite`,
          padding: `${borderWidth}px`
        }}
      />
      <div className="relative z-10 bg-background rounded-full">
        {children}
      </div>
      <style>{`
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default RotatingBorderLabel;
